import { ticketType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

// 型をエクスポート
export type ContactType = ticketType.contactType

// 連絡区分オプション
const contactTypeOptions = ticketType.CONTACT_TYPES.map((item) => ({
  value: item.key,
  label: item.value,
}))

interface ContactTypeSelectorProps {
  /** 選択された連絡区分 */
  value: ContactType | "" | string
  /** 値変更時のコールバック */
  onChange: (value: string) => void
  /** エラーメッセージ */
  error?: string
  /** プレースホルダー */
  placeholder?: string
  /** 無効状態 */
  disabled?: boolean
  /** CSSクラス */
  className?: string
}

export function ContactTypeSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: ContactTypeSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        options={contactTypeOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
